import React from 'react'
import clsx from 'clsx'

export function GridContainer (props) {
  const {
    children,
    full = false,
    fluid = false,
    className,
    hide = false
  } = props

  if (hide) {
    return null
  }

  let classes = clsx(
    `grid-container`,
    {
      'full': full,
      'fluid': fluid
    },
    className
  )

  return <div className={classes}>
    {children}
  </div>
}
